import React from "react";
import {autobind} from "core-decorators";
import {inject, observer} from "mobx-react";
import {message, Modal} from "antd";
import {DateTime} from "luxon";

import "./SubscriptionPricingTable.scss";
import {cancelTrial} from "@/lib/backend";
import Store from "@/stores";

export interface ISubscriptionTrialProps {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class SubscriptionTrial extends React.Component<ISubscriptionTrialProps> {
  cancelTrial() {
    Modal.confirm({
      title: "Cancel your free trial?",
      content:
        "After you cancel your trial, you cannot start another trial. Are you sure you want to cancel your trial?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          await cancelTrial();
          await this.props.store!.session.fetchSessionData();
        } catch (error) {
          console.error(error);
          message.error("An error occurred while cancelling your trial.");
        }
      },
    });
  }

  render() {
    const activeSubscription = this.props.store!.session.activeSubscription!;
    let trialEndString = "";
    if (activeSubscription.trial_end) {
      const trialEndFormatted = DateTime.fromISO(activeSubscription.trial_end).toFormat("DDD t");
      trialEndString = ` and will end ${trialEndFormatted}`;
    }

    return (
      <>
        Your free trial is currently active{trialEndString}. You can{" "}
        <a href="#cancel-trial" onClick={this.cancelTrial}>
          cancel your trial
        </a>{" "}
        or upgrade to a paid plan below.
      </>
    );
  }
}
